module.exports = __webpack_public_path__ + "img/no_task68.8a5b9bd5.png";